import { createFileRoute, redirect } from '@tanstack/react-router';
import { portalHome } from '@/lib/portal';

// `/portal` itself is no page: it is where this person starts.
export const Route = createFileRoute('/portal/_portal/')({
  beforeLoad: ({ context }) => {
    throw redirect({ to: portalHome(context.me) });
  },
});
